module.exports = __webpack_require__.p + "01ad2c9c7252e6a4710a7a611773691f.jpg";